<template>
    <div class="placeholder-wrap">
        <img class="emoji" :src="emoji"/>
        <p class="caption">{{caption}}</p>
        <p class="info">{{info}}</p>
    </div>
</template>

<script>
export default {
  props: {
    emoji: {
      type: String,
      default: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/320/apple/237/flying-saucer_1f6f8.png'
    },
    caption: {
      type: String,
      default: 'No data'
    },
    info: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
    .placeholder-wrap {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        color: $or-black-blue;
        display: flex;
        flex: 1 1 auto;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .emoji {
            width: 48px;
            height: 48px;
        }

        .caption {
            font-size: 18px;
            font-weight: bold;
            margin: 16px 0 4px;
        }

        .info {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            max-width: 300px;
        }
    }
</style>
